export async function getSellerSuggestionsForLeadTypes(
	hashedProjectId,
	leadTypes = ['marketplace'],
	bpvid,
) {
	return new Promise((resolve, reject) => {
		let url = `buyer/project/${hashedProjectId}/suggestions`;
		if (bpvid) {
			url += `?bpvid=${bpvid}`;
		}
		for (let i = 0; i < leadTypes.length; i++) {
			url += `&filter[leadTypes][${i}]=${leadTypes[i]}`;
		}
		window?.Bark?.api(
			url,
			{},
			function (data) {
				resolve(data);
			},
			function (error) {
				bugsnagClient &&
					bugsnagClient.notify(new Error(`Failed to get enquiries only sellers`));
				resolve({});
			},
			'GET',
			Bark.apiVersionHeader('v2'),
		);
	});
}
